__turbopack_context__.v({
  "button": "CapacityConflictFooter-module-scss-module___3a0pW__button",
  "destructive": "CapacityConflictFooter-module-scss-module___3a0pW__destructive",
  "footer": "CapacityConflictFooter-module-scss-module___3a0pW__footer",
});
